import { render, staticRenderFns } from "./MenuAppBarAccount.vue?vue&type=template&id=04e7f83a&"
import script from "./MenuAppBarAccount.vue?vue&type=script&lang=ts&"
export * from "./MenuAppBarAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports